import { useState } from 'react';

import StaffDashboard from '../custom/StaffDashboard'
export default function StaffPage() {
	
	const [pageReady, setPageReady] = useState(true);
	return (
		<main id="StaffPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <div className="">
                    <StaffDashboard/>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
